import { render, staticRenderFns } from "./PeriodsList.vue?vue&type=template&id=561052c0&scoped=true"
import script from "./PeriodsList.vue?vue&type=script&lang=js"
export * from "./PeriodsList.vue?vue&type=script&lang=js"
import style0 from "./PeriodsList.vue?vue&type=style&index=0&id=561052c0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "561052c0",
  null
  
)

export default component.exports